var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoaded)?_c('div',{staticClass:"sm-customer"},[_c('customer-top'),_c('customer-main')],1):_c('sm-spinner',{attrs:{"show":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }